import React, { ReactNode } from 'react';
import { classNames } from '../../utils/style';

export const AdditionalPrice = ({
  name = '',
  display,
  displayEmptyLines = [],
  className = '',
  children,
}: {
  name: string;
  display?: any;
  displayEmptyLines?: any[];
  children?: ReactNode;
  className?: string;
}) => {
  if (!display && displayEmptyLines.includes(name))
    return <div className={classNames(className)}>&nbsp;</div>;
  return <div className={classNames(className)}>{children}</div>;
};
